import { Box, Fab } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

function ButtonsScrollUp({ scrollToTop }) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 105,
        left: "0%",
        transform: "translateX(-1%)",
        maxWidth: "720px",
        width: "100%",
        display: "flex",
        paddingRight: "10px",
        zIndex: 9999,
      }}
    >
      <Fab color="inherit" id="scrollToTopNews" aria-label="scroll to top" onClick={scrollToTop} size="small" sx={{ position: "fixed", right: 12 }}>
        <ArrowUpwardIcon />
      </Fab>
    </Box>
  );
}

export default ButtonsScrollUp;
